import { EXPENSES_STATUSES, INCOME_STATUSES } from "./payorder";

export const CFD_INBOUND = 1;
export const CFD_OUTBOUND = 2;
export const CFD_CROSS = 3;

export type CashflowDirection = 1 | 2 | 3;
// export type CashflowDirection = CFD_INBOUND | CFD_OUTBOUND | CFD_CROSS;

export const CFD_TYPES: { [x in CashflowDirection]: string } = {
  1: 'Входящие',
  2: 'Исходящие',
  3: 'Совмещенные',
}

export const CFD_TYPES_KEYS = Object.keys(CFD_TYPES).map(Number);

/**
 * Подходит ли статья с направлением direction группе платёжки group.
 * Совмещённая статья (CFD_CROSS) подходит любой группе. Должна совпадать с проверкой на сервере (payorders-validation.service).
 */
export const isCashflowDirectionAllowedForGroup = (direction: CashflowDirection, group: number): boolean => {
  if (direction === CFD_INBOUND) return (INCOME_STATUSES as number[]).includes(group);
  if (direction === CFD_OUTBOUND) return (EXPENSES_STATUSES as number[]).includes(group);
  return true;
};
